import { render, staticRenderFns } from "./VMVCodeColumnModal.vue?vue&type=template&id=6a050c9e"
import script from "./VMVCodeColumnModal.vue?vue&type=script&lang=js"
export * from "./VMVCodeColumnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports